import { render, staticRenderFns } from "./ReviewManagement.vue?vue&type=template&id=13df007d&scoped=true&"
import script from "./ReviewManagement.vue?vue&type=script&lang=js&"
export * from "./ReviewManagement.vue?vue&type=script&lang=js&"
import style0 from "./ReviewManagement.vue?vue&type=style&index=0&id=13df007d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13df007d",
  null
  
)

export default component.exports